import { GetAvsInternalAccountsResponse } from "@/app/api/avs-internal-accounts/route";
import { getAvsInternalAccountsRequestSchema } from "@/lib/schemas/avs-internal-accounts";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const AVS_INTERNAL_ACCOUNTS_ENDPOINT = "/api/avs-internal-accounts";

export const invalidateAvsInternalAccountsQuery = createInvalidateQuery(
  AVS_INTERNAL_ACCOUNTS_ENDPOINT,
);

export const useAvsInternalAccountsQuery =
  createQueryHook<GetAvsInternalAccountsResponse>(
    AVS_INTERNAL_ACCOUNTS_ENDPOINT,
    getAvsInternalAccountsRequestSchema,
  );
